<template>
    <component :is="icon" :size="size" :stroke-width="strokeWidth" />
</template>

<script>
import { resolveIcon } from "../lib/icons.js";

export default {
    name: "BlockIcon",
    props: {
        name: { type: String, default: "" },
        size: { type: [Number, String], default: 24 },
        strokeWidth: { type: [Number, String], default: 2 },
    },
    computed: {
        icon() {
            return resolveIcon(this.name);
        },
    },
};
</script>
